import React from "react";
import { DKButton, DKLabel, DKInput, getCapitalized } from "deskera-ui-library";
import IAM from "../../services/iam";
import Tenant from "../../services/tenant";

class AddOrgPopup extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      orgName: "",
      saveOrgTapped: false,
    };
  }

  cancelTapped = () => {
    this.setState(
      {
        orgName: "",
      },
      () => {
        this.props.onCancel();
      }
    );
  };

  addTapped = () => {
    this.setState({ saveOrgTapped: true });
    if (this.state.orgName.trim() === "") {
      return;
    }

    Tenant.getOrgWithoutSetup({
      tenantName: this.state.orgName,
      isBookkeeper: false,
      refreshToken: "refreshToken",
    }).then((res) => {
      IAM.switchTenant({ tenantId: res.tenantId }).then((res) => {
        window.location.reload();
      });
    });
  };

  render() {
    return (
      <div className="transparent-background">
        <div className="popup-window" style={{ maxWidth: 400 }}>
          <div className="row justify-content-between">
            <DKLabel text="Add organisation" className="fw-m fs-l" />
            <div>
              <div className="row">
                <DKButton
                  title="Cancel"
                  className="bg-gray1 border-m fw-m"
                  onClick={this.cancelTapped}
                />
                <DKButton
                  title="Add"
                  className="bg-app ml-r text-white fw-m"
                  onClick={this.addTapped}
                />
              </div>
            </div>
          </div>

          <div className="column mt-r parent-width">
            <div className="row " style={{ alignItems: "flex-start" }}>
              <DKInput
                className="parent-width"
                title="Company name"
                required
                value={this.state.orgName}
                direction="vertical"
                onChange={(value) => {
                  this.setState({ orgName: getCapitalized(value) });
                }}
                canValidate={
                  this.state.saveOrgTapped && this.state.orgName.trim() === ""
                }
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddOrgPopup;
